export default "d8a3341116785a56.svg"